import type { UseQueryOptions } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";
import api from "../../../../../../api";
import urls from "../../../../../../urls";
import type { VollmachtFiles } from "../../../../../../utils/backend-types";

export const vollmachtMsbFilesQueries = {
  all: () =>
    queryOptions<VollmachtFiles>({
      queryKey: ["vollmachtMsbFiles"]
    }),
  bySiteId: (
    siteId: number,
    options?: Partial<UseQueryOptions<VollmachtFiles>>
  ) =>
    queryOptions<VollmachtFiles>({
      queryKey: ["vollmachtMsbFiles", { siteId }],
      queryFn: () => fetchVollmachtMsbFiles(siteId),
      ...options
    })
};

export function useVollmachtMsbFiles(
  siteId: number,
  options?: Partial<UseQueryOptions<VollmachtFiles>>
) {
  return useQuery(vollmachtMsbFilesQueries.bySiteId(siteId, options));
}

async function fetchVollmachtMsbFiles(siteId: number) {
  const msbFilesUrl = urls.api.vollmachtMsbFiles(siteId);
  const response = await api.get<VollmachtFiles>(msbFilesUrl);
  return response.data;
}
